var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.391 12.4327L11.45 19.2929C9.64629 21.0849 7.21929 20.9076 5.67054 19.3582C4.11235 17.8275 3.93292 15.4474 5.73665 13.6554L15.2086 4.30311C16.2946 3.22974 17.8905 3.08041 18.9293 4.09777C19.9587 5.1338 19.8076 6.70185 18.731 7.77521L9.47631 16.9221C9.01357 17.3982 8.44696 17.2582 8.12587 16.9408C7.80479 16.6141 7.67258 16.0728 8.13532 15.5968L14.6042 9.22192C14.8875 8.93258 14.9064 8.5219 14.6325 8.25123C14.3586 7.98988 13.9431 8.00855 13.6598 8.28856L7.17207 14.7008C6.20883 15.6528 6.2466 17.1088 7.09652 17.9488C8.02199 18.8635 9.41964 18.8449 10.3923 17.8835L19.6848 8.69924C21.4508 6.95385 21.3752 4.65779 19.8359 3.13641C18.3344 1.65236 15.9735 1.54036 14.2075 3.28575L4.68841 12.7034C2.35584 15.0088 2.53527 18.3035 4.64119 20.3849C6.74711 22.457 10.0807 22.6343 12.4133 20.3383L19.4015 13.4314C19.6754 13.1607 19.6754 12.666 19.3921 12.414C19.1182 12.1247 18.6744 12.162 18.391 12.4327Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon-attachment.1842e514e5734f0cfec7ff4386c5f6ab.svg";
export { ForwardRef as ReactComponent };